import * as z from "zod";

export const returnFormSchema = z.object({
  name: z.string().min(2, {
    message: "Name must be at least 2 characters.",
  }),
  email: z.string().email({
    message: "Please enter a valid email address.",
  }),
  orderNumber: z.string().min(1, {
    message: "Order number is required.",
  }),
  productName: z.string().min(1, {
    message: "Product name is required.",
  }),
  reason: z.string().min(1, {
    message: "Please select a reason for return.",
  }),
  message: z.string().min(10, {
    message: "Additional details must be at least 10 characters.",
  }),
});

export type ReturnFormData = z.infer<typeof returnFormSchema>;
